import { startOfDay } from 'date-fns';
import React, { useState } from 'react';
import { useIntl } from 'react-intl';
import { noop } from '../../utils/noop.esm.js';
import '@popperjs/core';
import { Button } from '../Button/Button.esm.js';
import '@panwds/icons';
import '@panwds/tailwindcss';
import '../Icon/ImgIcon.esm.js';
import '../Icon/SemanticIcons.esm.js';
import '../Button/ProgressButton.esm.js';
import '../Button/CopyButton.esm.js';
import { Field } from '../Field/Field.esm.js';
import { Calendar } from './Calendar/Calendar.esm.js';
import { MAX_DATE, MIN_DATE } from './constants.esm.js';
import { DateInput } from './DateInput.esm.js';
import { DatePickerLayout } from './DatePickerLayout.esm.js';
import { cancelMessage, applyMessage } from './messages.esm.js';
import { useActiveDate } from './useActiveDate.esm.js';
import { useDateRangeState } from './useDateRangeState.esm.js';

/**
 * Allows the user to navigate a calendar and select a date range.
 *
 * ### Import Guide
 *
 * ```jsx
 * import { DateRangePicker } from "@panwds/react-ui";
 * ```
 */
const DateRangePicker = ({ dataMetrics, dataTestId, initialActiveDate = startOfDay(new Date()), initialDateRange, max = MAX_DATE, min = MIN_DATE, onApply, onCancel = noop, weekStartsOn = 0, disabled = false }) => {
    const intl = useIntl();
    const [activeDate, setActiveDate] = useActiveDate({
        initialActiveDate,
        max,
        min
    });
    const { selectDate, setEndDate, setStartDate, dateRange } = useDateRangeState(initialDateRange, min, max);
    const [hoverDate, setHoverDate] = useState();
    function handleSelectDate(next) {
        selectDate(next);
        setActiveDate(next);
        setHoverDate(undefined);
    }
    return (React.createElement(DatePickerLayout, { dataMetrics: dataMetrics, dataTestId: dataTestId || 'date-range-picker', actions: React.createElement(React.Fragment, null,
            React.createElement(Button, { onClick: () => {
                    onCancel();
                }, disabled: disabled }, intl.formatMessage(cancelMessage)),
            React.createElement(Button, { appearance: "primary", disabled: !dateRange.end || !dateRange.start || disabled, onClick: () => {
                    onApply(dateRange);
                } }, intl.formatMessage(applyMessage))), calendar: React.createElement(Calendar, { activeDate: activeDate, hoverDate: hoverDate, max: max, min: min, onActiveDateChange: setActiveDate, onHoverDateChange: setHoverDate, onSelectedDateChange: handleSelectDate, dateRange: dateRange, weekStartsOn: weekStartsOn }), inputs: React.createElement("div", { className: "tw-flex tw-space-x-1" },
            React.createElement(Field, { label: intl.formatMessage({
                    defaultMessage: 'From Date',
                    id: '11vs47',
                    description: 'Input Label for start date in range'
                }), showLabel: false, control: React.createElement(DateInput, { formatPattern: "Pp", max: max, min: min, selectedDate: dateRange.start, onSelectDate: setStartDate }) }),
            React.createElement(Field, { label: intl.formatMessage({
                    defaultMessage: 'To Date',
                    id: 'LFcisT',
                    description: 'Input Label for end date in range'
                }), showLabel: false, control: React.createElement(DateInput, { formatPattern: "Pp", max: max, min: min, selectedDate: dateRange.end, onSelectDate: setEndDate }) })) }));
};

export { DateRangePicker };
//# sourceMappingURL=DateRangePicker.esm.js.map
